import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverEffect?: boolean;
  glow?: 'emerald' | 'cyan' | 'none';
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  hoverEffect = true,
  glow = 'none',
  children,
  className,
  ...props
}) => {
  const glowStyles = {
    emerald: 'glow-emerald border-emerald-200/80',
    cyan: 'glow-cyan border-sky-200/80',
    none: 'border-slate-200/80',
  };

  return (
    <div
      className={twMerge(
        clsx(
          'glass-panel rounded-2xl p-6 sm:p-8 relative overflow-hidden transition-all duration-300',
          hoverEffect && 'glass-panel-hover',
          glowStyles[glow],
          className
        )
      )}
      {...props}
    >
      {children}
    </div>
  );
};
